import { WEB_SAFE_FONTS } from '@wix/shoutout-email-model-v3';
const HARDCODED_SYSTEM_FONT_NAMES = Object.values(WEB_SAFE_FONTS).map(font => font.displayName.toLowerCase());
export const isSystemFont = displayName => HARDCODED_SYSTEM_FONT_NAMES.includes(displayName.toLowerCase());
//# sourceMappingURL=isSystemFont.js.map